module.exports = __webpack_public_path__ + "static/media/rich.139a1691.jpg";